import Nullstack from 'nullstack';
export default function IconLanguageKatakana({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-language-katakana",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M5 5h6.586a1 1 0 0 1 .707 1.707l-1.293 1.293"
  }), "   ", Nullstack.element("path", {
    d: "M8 8c0 1.5 .5 3 -2 5"
  }), "   ", Nullstack.element("path", {
    d: "M12 20l4 -9l4 9"
  }), "   ", Nullstack.element("path", {
    d: "M19.1 18h-6.2"
  }), " ");
}